<script lang="ts" setup>
import { isTaxCatalogActiveKey } from '~/lib/interfaces/symbols'
import { ProductEcommerce, ProductEcommerceLite } from '~/lib/services/store/catalog/catalog.dtos'

const { product } = defineProps<{ product: ProductEcommerce | ProductEcommerceLite }>()

const { format } = useFormatAmount()
const { t } = useLocale()
const { userSegmentation } = useProductPromos()

const isTaxCatalogActive = inject(isTaxCatalogActiveKey)!

const validPromo = computed(() => {
  return validPromoForBubble(product.promotions, userSegmentation.value) || null
})
const originalPrice = computed(() => {
  const unifiedPrice = product.unifiedPrice
  const amount = unifiedPrice ? unifiedPrice.amount : product.price.amount || 0
  return format(amount)
})
const displayFinalPrice = computed(() => {
  const unifiedPrice = product.unifiedPrice
  const priceWithDiscount = validPromo.value?.prices?.priceWithDiscount
  return priceWithDiscount || priceWithDiscount === 0
    ? format(priceWithDiscount)
    : `${unifiedPrice ? t('common.priceFrom') : ''}${originalPrice.value}`
})

const netAmountPrice = computed(() => {
  if (!isTaxCatalogActive.value || !product.price.netAmount) {
    return ''
  }
  const netAmountWithDiscount = validPromo.value?.prices?.netAmountWithDiscount

  return t('common.netAmountInfo', {
    price: netAmountWithDiscount ? format(netAmountWithDiscount) : format(product.price.netAmount),
  })
})
</script>

<template>
  <div class="flex flex-col items-start gap-1">
    <div class="flex flex-row flex-wrap items-center gap-2">
      <p
        v-if="validPromo !== null"
        data-test="original-price"
        class="text-sm text-mcd-secondaryDarkGrey md:text-base"
      >
        <del>{{ originalPrice }}</del>
      </p>
      <p class="text-sm font-bold text-mcd-black md:text-base">{{ displayFinalPrice }}</p>
    </div>
    <p v-if="netAmountPrice" data-test="net-price" class="text-xs text-mcd-secondaryDarkGrey">
      {{ netAmountPrice }}
    </p>
  </div>
</template>
